// extracted by mini-css-extract-plugin
export var numberInputContainer = "_73-0";
export var startPickingButton = "_73-1";